import { Serializable } from '@/models/core/serializable';
import { SchoolClass } from '@/models/school-class/school-class';
import { GEnum } from '@/constants/enum.defination';
import { store } from '@/store';

export class Teacher implements Serializable<Teacher> {
  accessEntryID: number = 0;
  companyID: number = 0;
  createdAt: string = '';
  email: string = '';
  firstName: string = '';
  fullName: string = '';
  fullNameByLang: string = '';
  lastName: string = '';
  role: number = GEnum.Role.Normal;
  schoolClasses: SchoolClass[] = [];
  teacherID: number = 0;
  updatedAt: string = '';
  password: string = '';
  confirmPassword: string = '';
  isValid: boolean = true;

  isValidRadio: GEnum.RadioLabel = GEnum.RadioLabel.True;

  deserialize(input: any): Teacher {
    this.accessEntryID = input.accessEntryID;
    this.companyID = input.companyID;
    this.createdAt = input.createdAt;
    this.email = input.email;
    this.firstName = input.firstName;
    this.fullName = input.fullName;
    this.lastName = input.lastName;
    this.role = input.role;
    if (input.schoolClasses) {
      this.schoolClasses = input.schoolClasses.map((schoolClass: SchoolClass) => new SchoolClass().deserialize(schoolClass));
    }
    this.teacherID = input.teacherID;
    this.updatedAt = input.updatedAt;
    if (input.isValid !== undefined) {
      this.isValid = input.isValid;
      this.isValidRadio = this.isValid ? GEnum.RadioLabel.True : GEnum.RadioLabel.False;
    }

    // 氏名の設定
    // 現在の言語設定により設定される
    // 言語切り替えにより、currentLang が変化 => currentLang に 名前の順（boolean）を保持している
    if (store.getters.isNameOrder) {
      // 日本語と同じ 姓 + 名
      this.fullNameByLang = `${input.lastName} ${input.firstName}`;
    } else {
      // 日本語とは異なる 名 + 姓
      this.fullNameByLang = `${input.firstName} ${input.lastName}`;
    }

    return this;
  }

  get isValidTrue(): boolean {
    return this.isValidRadio === GEnum.RadioLabel.True;
  }

  get isValidFalse(): boolean {
    return this.isValidRadio === GEnum.RadioLabel.False;
  }

  get isAdmin(): boolean {
    return this.role === GEnum.Role.Admin;
  }
  get isIGSAdmin(): boolean {
    return this.role === GEnum.Role.IgsAdmin;
  }
  get isNormal(): boolean {
    return this.role === GEnum.Role.Normal;
  }
}
